import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import Alert from '@material-ui/lab/Alert';
import { FabricaInsumosInstrucoes } from './components/FabricaInsumosInstrucoes/FabricaInsumosInstrucoes';
import { FabricaInsumosProducao } from './components/FabricaInsumosProducao/FabricaInsumosProducao';
import { fabricarInsumos, getAllInsumos } from '../../services/InsumoService';
import { Values } from '../../values/Values';
import { FabricaInsumosAppbar } from './components/FabricaInsumosAppbar/FabricaInsumosAppbar';
import DialogConfirmacao from '../../components/DialogConfirmacao/DialogConfirmacao';
import DialogContentText from '@material-ui/core/DialogContentText';


const FabricaInsumos = props => {
  const { history } = props;
  const [mostrarInstrucoes, setMostrarInstuicoes] = useState(true);
  const [loading, setLoading] = React.useState(false);
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const [insumosOrigem, setInsumosOrigem] = useState([]);
  const [insumosDestino, setInsumosDestino] = useState([]);
  const [insumos, setInsumos] = useState([]);
  const [abrirDialogCancelar, setAbrirDialogCancelar] = useState(false);
  const [abrirDialogFinalizar, setAbrirDialogFinalizar] = useState(false);

  useEffect(() => {
    getInsumos();
  }, []);

  async function getInsumos() {
    try{
      setLoading(true);
      let retorno = await getAllInsumos(5000, 1);
      if(retorno.isSuccess) {
        setLoading(false);
        setInsumos(retorno.result);
      }
      else{
        setLoading(false);
        setMessageSnack(retorno.message);
        setTypeSnack('error');
        setShowMessageSnack(true);
      }
    }
    catch (e) {
      setLoading(false);
      setMessageSnack(Values.MessageValues.erro_catch);
      setTypeSnack('error');
      setShowMessageSnack(true);
    }
  }

  async function fabricar(event) {
    try{
      event.preventDefault();
      setAbrirDialogFinalizar(false);
      setLoading(true);
      const auth = JSON.parse(localStorage.getItem('auth'));
      let retorno = await fabricarInsumos(auth.result.idUsuario, insumosOrigem, insumosDestino);
      if(retorno.isSuccess) {
        setLoading(false);
        setMostrarInstuicoes(true);
        setMessageSnack(retorno.message);
        setTypeSnack('success');
        setShowMessageSnack(true);
      }
      else{
        setLoading(false);
        setMessageSnack(retorno.message);
        setTypeSnack('error');
        setShowMessageSnack(true);
      }
    }
    catch (e) {
      setLoading(false);
      setMessageSnack(Values.MessageValues.erro_catch);
      setTypeSnack('error');
      setShowMessageSnack(true);
    }
  }

  function cancelar(event) {
    event.preventDefault();
    setInsumosOrigem([]);
    setInsumosDestino([]);
    setMostrarInstuicoes(true);
    setAbrirDialogCancelar(false);
  }

  function abrirDialogConfimacaoCancelamento() {
    setAbrirDialogCancelar(true);
  }

  function abrirDialogConfimacaoFinalizacao() {
    setAbrirDialogFinalizar(true);
  }


  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={12}
        xs={12}
      >
        <ProgressFullScreen
          open={loading}
          setOpen={setLoading}
        />
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
      >
        <DialogConfirmacao
          mensagemBotaoEsquerda={'CANCELAR'}
          mensagemBotaoDireita='FINALIZAR'
          acaoBotaoEsquerda={() => {setAbrirDialogFinalizar(false)}}
          acaoBotaoDireita={fabricar}
          componenteExtraDialogContent={
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                md={12}
                xs={12}
              >
                <DialogContentText id={'mensagemPrincipalDialog'}>
                  {`Tem certeza que deseja finalizar o processo de fabricação? Ao encerrar esse processo, o
                  estoque dos seus insumos será alterado de acordo com os itens selecionados na tela`}
                </DialogContentText>
              </Grid>
              <Grid
                item
                md={12}
                xs={12}
              >
                <Alert variant={'outlined'} severity={'warning'}>ATENÇÃO: ESSE PROCESSO NÃO PODE SER DESFEITO!</Alert>
              </Grid>
            </Grid>
          }
          tituloDialog={'Deseja finalizar?'}
          open={abrirDialogFinalizar}
        />
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
      >
        <DialogConfirmacao
          mensagemBotaoEsquerda={'FECHAR'}
          mensagemBotaoDireita='OK'
          acaoBotaoEsquerda={() => {setAbrirDialogCancelar(false)}}
          acaoBotaoDireita={cancelar}
          mensagemPrincipal='Tem certeza que deseja cancelar a fabricação de insumos? Todo seu progresso será perdido'
          tituloDialog={'Cancelar fabricação?'}
          open={abrirDialogCancelar}
        />
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
      >
        <SnackbarCustom
          verticalOrientation='bottom'
          horizontalOrientation='center'
          open={showMessageSnack}
          setOpen={setShowMessageSnack}
          message={messageSnack}
          duration={5000}
          type={typeSnack}
        />
      </Grid>
      {
        mostrarInstrucoes &&
        <Grid
          item
          md={12}
          xs={12}
        >
          <FabricaInsumosInstrucoes
            setMostrarInstrucoes={setMostrarInstuicoes}
          />
        </Grid>
      }
      {
        !mostrarInstrucoes &&
        <Grid
          item
          md={12}
          xs={12}
        >
          <FabricaInsumosAppbar
            fabricar={abrirDialogConfimacaoFinalizacao}
            cancelar={abrirDialogConfimacaoCancelamento}
          />
        </Grid>
      }
      {
        !mostrarInstrucoes &&
        <Grid
          item
          md={12}
          xs={12}
        >
          <FabricaInsumosProducao
            setMostrarInstrucoes={setMostrarInstuicoes}
            insumos={insumos}
            insumosOrigem={insumosOrigem}
            setInsumosOrigem={setInsumosOrigem}
            insumosDestino={insumosDestino}
            setInsumosDestino={setInsumosDestino}
            setTypeSnack={setTypeSnack}
            setMessageSnack={setMessageSnack}
            setShowMessageSnack={setShowMessageSnack}
            setLoading={setLoading}
          />
        </Grid>
      }
    </Grid>
  )
};
FabricaInsumos.propTypes = {
  history: PropTypes.object
};

export default withRouter(FabricaInsumos);
